import React from 'react';
import { useSelector } from 'react-redux';
import { ExperimentId } from '../../../common/experiments/experimentsConstants';
import { getIsFeatureEnabledForCurrentUser } from './elementFeatureSelector';

/**
 * HOC to swap between two components based on a feature flag.
 * (will try to use the prop typechecking for the flag-enabled component)
 */
export const createFeatureToggledComponent = <T extends {}>( // "extends {}" just so that TS doesn't think this is a JSX expression
    featureId: ExperimentId,
    EnabledComponent: React.ComponentClass<T, any> | React.FC<T>,
    DisabledComponent: React.ComponentClass<any, any> | React.FC<any>,
) =>
    React.forwardRef((props: T, ref) => {
        const isFeatureEnabled = useSelector(getIsFeatureEnabledForCurrentUser(featureId));
        const Component = isFeatureEnabled ? EnabledComponent : DisabledComponent;

        return <Component {...props} ref={ref} />;
    });
